// @Deprecated: This component is not used anymore, it was replaced by the UploadImageModal component
// To remove when we are done with the light mode transition

// Third-party
import React from 'react';
import cropperjs from 'cropperjs';

// Components
import { CancelButton } from '../buttons';
import { ImageUpload } from '../image-upload';
import Modal from '@/views/components/modals/AccessibleModal';

// Redux
import { cropBrandingLogo } from '@/redux/modules/auth/index';

// Utils
import { FormattedMessage } from '@/utils/i18n';
import { ReduxState } from '@/redux/modules/types';
import { connect } from 'react-redux';

// Types
import User from '@/types/user';

type DispatchProps = {
  cropBrandingLogo: (imgUrl: string, fileType: string, dimensions: cropperjs.Data) => Promise<string>;
};

type StateProps = {
  user?: User | null;
};

type Props = StateProps &
  DispatchProps & {
    show: boolean;
    onCancel: () => void;
    titleId: string;
  };

const UploadPhotoModal = (props: Props) => (
  <Modal show={props.show} className="upload-image-modal" onHide={props.onCancel} dialogClassName="modal-dialog-centered">
    <Modal.Header closeButton>
      <Modal.Title>
        <FormattedMessage id={props.titleId} />
      </Modal.Title>
    </Modal.Header>

    <Modal.Body className="d-flex flex-column">
      <ImageUpload
        onSave={props.onCancel}
        targetImg={props.user?.coBranding?.logoUrl}
        labelPrefix="LogoUpload"
        onUpload={props.cropBrandingLogo}
        errorKey="SAVE_LOGO_ERROR"
      />
    </Modal.Body>

    <Modal.Footer className="justify-content-end">
      <CancelButton onClick={props.onCancel} />
    </Modal.Footer>
  </Modal>
);
const mapStateToProps = (state: ReduxState) => ({
  user: state.auth.user,
});

export default connect(mapStateToProps, {
  cropBrandingLogo,
})(UploadPhotoModal);
